// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + ({"53":"webfontloader","207":"timeregistration","594":"about"}[chunkId] || chunkId) + "." + {"53":"9380816b","125":"e3762e1b","179":"7eceb685","207":"26f4bfc3","330":"c5144167","594":"b8d20e5c"}[chunkId] + ".js";
};